import React, {Component} from 'react';
import Result from './Result';
import SearchField from './SearchField'
import ReactPaginate from 'react-paginate';
import {connect} from 'react-redux'
import {Saga} from './actions';
import * as selectors from './selectors';
import ModalContainer from '../ui/modal/Modals';
import MessagePortal from '../ui/messages/Portal'

class DocumentSearch extends Component {

  render() {
    let results = []

    if (this.props.results) {
      results = this.props.results.map((result, index) => {
        return (
          <Result key={result.documentId} {...result} />
        );
      })
    }

    return (
      <div>

        <MessagePortal>
          {this.props.searching && !this.props.validationError && !this.props.searchLoading && this.props.results && this.props.results.length <= 0 &&
          <div className="alert alert-info">
            <span>No Results found that match the specified criteria.</span></div>
          }
          {this.props.validationError &&
          <div className="alert alert-danger">
            <span>There were errors in your input. Please see highlighted issues below.</span>
          </div>
          }
          {this.props.globalErrors &&
          this.props.globalErrors.map((errorMsg, index) => {
            return (
              <div key={index} className="error">
                <span>{errorMsg}</span>
              </div>
            );
          })
          }


        </MessagePortal>


        <div className='section'>

          <ModalContainer/>

          <div className='section-header'>
            <h3>Document Search</h3>
          </div>

          <SearchField/>

          <div className='search-results-container' style={{position: 'relative'}}>

            {this.props.searchLoading && <div className="loader">
              <div className="d-flex justify-content-center mt-5">
                {this.props.results && this.props.results.length > 0 &&
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>}
              </div>
            </div>}

            {this.props.results && this.props.results.length > 0 &&
            <p className='text-muted'>Showing {this.props.resultsShown} result(s)
              of {this.props.resultTotal} </p>}

            <div className='list-group'>

              {results}

              {this.props.results && this.props.results.length > 0 &&

              <nav aria-label="Document search pagination">
                <ReactPaginate
                  initialPage={this.props.pageStart}
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.props.totalPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.props.loadNextPage}
                  containerClassName={"pagination mt-3 justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  activeClassName={"active"}
                  previousClassName={"page-item"}
                  nextClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextLinkClassName={"page-link"}
                >

                </ReactPaginate>

              </nav>}

            </div>
          </div>

        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  pageStart: selectors.getPageStart(state),
  searching: selectors.getSearchTerm(state),
  results: selectors.getResults(state),
  resultTotal: selectors.getTotalResults(state),
  resultsShown: selectors.getResultsShowing(state),
  hasMore: !selectors.isLastPage(state),
  searchLoading: selectors.isSearchLoading(state),
  totalPages: selectors.getTotalPages(state),
  validationError: selectors.getSearchTermErrors(state),
  globalErrors: selectors.getValidationGlobalErrors(state)
});

const mapDispatchToProps = dispatch => ({
  loadNextPage: ({selected}) => {
    dispatch(Saga.loadNextSearchPage(selected))
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentSearch);